import gql from 'graphql-tag';

export const POST_QUERY = gql`
  query NewQuery($id: ID!) {
    post(id: $id) {
      content
    }
  }
`;
